import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Get a specific component
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestGetComponent = packet => {
  return {
    type: 'REQUEST_GET_COMPONENT',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveGetComponentSuccess = data => ({
  type: 'RECEIVE_GET_COMPONENT_SUCCESS',
  data
})

export const receiveGetComponentFail = data => ({
  type: 'RECEIVE_GET_COMPONENT_FAIL',
  data
})

export const tryToGetComponent = packet => (dispatch, getState) => {

  dispatch(requestGetComponent(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;

  return fetch('/api/components/' + packet.id, {
      method: 'get',
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveGetComponentSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveGetComponentFail({errors:e, lastSubmit: packet}));
    })
}
